<template>
  <div>
    <main-scn
      :title="$t('greenPolitic.mainTitle')"
      :highlighted-word-index="5"
      image-url-path="footer-links/fundo-politica-verde.jpg"
    />
    <scn>
      <section-header
        green
        :title="$t('greenPolitic.introduction.title')"
        :subtitle="$t('greenPolitic.introduction.subtitle')"
      />
      <div class="scn__content container">
        <div class="two-col-content two-col-content--sm-l sm-l:items-center md:items-center">
          <div class="two-col-content__col mr-2 md:mr-0 md:pr-5">
            <p v-for="paragraph in $t('greenPolitic.introduction.paragraphs')" class="mb-3">
              {{ paragraph }}
            </p>
          </div>
          <div class="two-col-content__col mt-4 sm-l:mt-0 md:mt-0 md:p-5">
            <img :src="$getImage('footer-links/reduza-reuse-recicle-respeite.svg')" :alt="`${$t('alt.logo')} Onesti`">
          </div>
        </div>
        <section-subtitle :title="$t('greenPolitic.documents.title')" :highlighted-word-index="4" green />
        <p
          v-for="(paragraph, index) in $t('greenPolitic.documents.paragraphs')"
          :class="index === $t('greenPolitic.documents.paragraphs').length - 1 ? 'mb-4' : 'mb-2'"
        >
          {{ paragraph }}
        </p>
        <div class="flex items-center">
          <div class="md:w-1/2">
            <section-subtitle :title="$t('greenPolitic.energy.title')" :highlighted-word-index="4" green />
            <p
              v-for="(paragraph, index) in $t('greenPolitic.energy.paragraphs')"
              :class="index === $t('greenPolitic.energy.paragraphs').length - 1 ? 'mb-4' : 'mb-2'"
            >
              {{ paragraph }}
            </p>
            <section-subtitle :title="$t('greenPolitic.providers.title')" green />
            <p
              v-for="(paragraph, index) in $t('greenPolitic.providers.paragraphs')"
              :class="index === $t('greenPolitic.providers.paragraphs').length - 1 ? 'mb-4' : 'mb-2'"
            >
              {{ paragraph }}
            </p>
          </div>
          <div class="together-stronger-image">
            <img :src="$getImage('footer-links/juntos-somos-mais-fortes.svg')" :alt="`${$t('alt.logo')} Onesti`">
          </div>
        </div>
        <div class="flex lg:mb-3">
          <div class="cut-log-image">
            <img :src="$getImage('footer-links/tronco-cortado.png')" :alt="`${$t('alt.logo')} Onesti`">
          </div>
          <div class="md:w-1/2">
            <section-subtitle :title="$t('greenPolitic.electronics.title')" :highlighted-word-index="1" green />
            <p
              v-for="(paragraph, index) in $t('greenPolitic.electronics.paragraphs')"
              :class="index === $t('greenPolitic.electronics.paragraphs').length - 1 ? 'mb-4' : 'mb-2'"
            >
              {{ paragraph }}
            </p>
            <section-subtitle :title="$t('greenPolitic.proBono.title')" :highlighted-word-index="[1, 2]" green />
            <p
              v-for="(paragraph, index) in $t('greenPolitic.proBono.paragraphs')"
              :class="index === $t('greenPolitic.proBono.paragraphs').length - 1 ? 'mb-4' : 'mb-2'"
            >
              {{ paragraph }}
            </p>
          </div>
        </div>
        <section-subtitle :title="$t('greenPolitic.citizenship.title')" green />
        <p
          v-for="(paragraph, index) in $t('greenPolitic.citizenship.paragraphs')"
          :class="index === $t('greenPolitic.citizenship.paragraphs').length - 1 ? 'mb-4' : 'mb-2'"
        >
          {{ paragraph }}
        </p>
        <download-button pdf-file-name="iniciativa-verde.pdf" />
      </div>
    </scn>
  </div>
</template>

<script>
import MainScn from '@/components/main-scn'
import SectionSubtitle from '@/components/section-subtitle'
import DownloadButton from '@/components/download-button'
export default {
  name: 'GreenPolitic',
  components: { DownloadButton, SectionSubtitle, MainScn }
}
</script>

<style scoped lang="sass">
@tailwind utilities

.together-stronger-image
  @apply hidden
  @screen md
    @apply block w-1/2 px-4

.cut-log-image
  @apply hidden
  @screen md
    @apply flex items-center w-1/2 mr-3 px-3 pl-0
</style>
